module.exports = __webpack_public_path__ + "img/shadow.93d98c72.svg";